export var InfoPaths;
(function (InfoPaths) {
    InfoPaths["DEPOSIT"] = "deposit";
    InfoPaths["WITHDRAW_METHODS"] = "withdraw-methods";
    InfoPaths["WITHDRAW_CRYPTO_FEE"] = "withdraw-crypto-fee";
    InfoPaths["CONVERT_FEE"] = "convert-fee";
})(InfoPaths || (InfoPaths = {}));
export var FeesTablesSelectorId;
(function (FeesTablesSelectorId) {
    FeesTablesSelectorId["OPTION_LIST"] = "option-list";
    FeesTablesSelectorId["TABLE"] = "table";
    FeesTablesSelectorId["EXCHANGE_FEES_TABLE"] = "exchange-fees-table";
})(FeesTablesSelectorId || (FeesTablesSelectorId = {}));
//# sourceMappingURL=feesEnums.js.map